function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint class-methods-use-this: "off" */
import { flushSync } from 'react-dom';
import { GridMouseHandler } from '@deephaven/grid';
/**
 * Detects mouse hover over column headers and displays the appropriate tooltip
 */
class IrisGridColumnTooltipMouseHandler extends GridMouseHandler {
  constructor(irisGrid) {
    super();
    _defineProperty(this, "irisGrid", void 0);
    this.irisGrid = irisGrid;
  }
  hideColumnTooltip() {
    var tooltip = this.irisGrid.tooltip;
    if (tooltip) {
      tooltip.stopTimer();
      tooltip.hide();
    }
  }
  onDown() {
    this.hideColumnTooltip();
    return false;
  }
  onContextMenu() {
    this.hideColumnTooltip();
    return false;
  }
  onWheel() {
    this.hideColumnTooltip();
    return false;
  }
  onLeave(gridPoint, grid, event) {
    /**
     * This should always be a react event
     * React seems to be handling onMouseLeave incorrectly at times
     * When moving to the padding between the column and popper, React sets
     * event.relatedTarget to window, but event.nativeEvent.relatedTarget is the popper.
     * It's possibly related to popper being rendered in a portal
     */
    var _ref = event instanceof MouseEvent ? event : event.nativeEvent,
      relatedTarget = _ref.relatedTarget;
    var tooltip = this.irisGrid.tooltip;
    if (!tooltip) {
      return false;
    }
    var popper = tooltip.popper.current;
    if (popper && relatedTarget instanceof Element && popper.element.contains(relatedTarget)) {
      // Do not hide the popper if we moved the cursor from canvas to popper
      return false;
    }
    this.hideColumnTooltip();
    return false;
  }
  onMove(gridPoint) {
    var column = gridPoint.column,
      row = gridPoint.row,
      columnHeaderDepth = gridPoint.columnHeaderDepth;
    var shownColumnTooltip = this.irisGrid.state.shownColumnTooltip;
    var newTooltip = null;
    if (column !== null && row === null && columnHeaderDepth === 0) {
      newTooltip = column;
    }
    if (newTooltip !== shownColumnTooltip) {
      flushSync(() => {
        this.irisGrid.setState({
          shownColumnTooltip: newTooltip
        });
      });
    }
    return false;
  }
}
export default IrisGridColumnTooltipMouseHandler;
//# sourceMappingURL=IrisGridColumnTooltipMouseHandler.js.map